<template>
  <TrackerLocation v-if="vehicle" :vehicle="vehicle" />
  <div v-else class="error">
    <h2>Vehicle not found</h2>
    <p>The requested vehicle could not be found.</p>
  </div>
</template>

<script>
import TrackerLocation from '@/components/TrackerLocation.vue'
import { getVehicleByRouteId } from '@/config/vehicles.js'

export default {
    name: 'VehicleRoute',
    components: {
        TrackerLocation
    },
    computed: {
        vehicle() {
            return getVehicleByRouteId(this.$route.params.vehicleId)
        }
    }
}
</script>

<style scoped>
.error {
    text-align: center;
    padding: 2rem;
}
</style>